import React from "react";
import { Box, Heading, Text, Stack, Link } from "@chakra-ui/react";
import Footer from "component/header/Footer";


const PrivacyPolicy = () => {

  return (
    <>
    <Box maxW="6xl" mx="auto" px={{ base: 4, md: 10 }} py={20} bg="white">
      <Heading as="h1" fontSize="3xl" textAlign={'center'} mb={6}>
        Privacy Policy
      </Heading>

      <Text mb={6}>
        Your privacy is important to us, and maintaining your trust and confidence is one of our highest priorities.
        Please read the Privacy Policy of <b>Doggle India</b> carefully. By visiting this website (“Website”) and/or
        sharing information with us, you agree to be bound by this Privacy Policy.
      </Text>

      <Text mb={6}>
        We respect your right to privacy and assure you that any personal information which you share with us —
        such as your name, address, contact number, email ID, or any other data — shall be kept strictly confidential.
        We do not sell or rent your details to any third parties.
      </Text>

      <Text mb={6}>
        Should you choose to share your personal information with us, Doggle India will assume that you have no objections
        to the terms of this Privacy Policy. If you do not agree with these terms, we request you to exit the site.
        This Privacy Policy may be revised or updated by us at any time to improve clarity or incorporate changes in law or technology.
      </Text>

      <Stack spacing={8} mt={10}>
        <Box>
          <Heading fontSize="xl" mb={2}>General Rules</Heading>
          <Text>
            Visitors may not use the Website in order to transmit, distribute, store, or destroy material:
          </Text>
          <Text mt={2}>
            <b>(a)</b> that could encourage conduct considered a criminal offense or violate applicable law, <br />
            <b>(b)</b> that infringes on intellectual property or personal rights of others, or <br />
            <b>(c)</b> that is defamatory, obscene, offensive, threatening, or otherwise objectionable.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>1. Use and Disclosure of Personal Information</Heading>
          <Text>
            None of your personal information shall be used or disclosed by us except for the purpose of conducting our
            business with you, or when required by law.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>2. Data Security</Heading>
          <Text>
            Although we use reasonable and up-to-date security measures to protect your information, Doggle India shall not
            be responsible for any unauthorized access or misuse of your personal information due to the nature of the online environment.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>3. Intellectual Property</Heading>
          <Text>
            You may not reproduce, sell, distribute, modify, or publicly display any content from this Website — including
            logos, branding elements, or visual assets — without written permission from Doggle India.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>4. Website Security</Heading>
          <Text>
            Visitors are prohibited from probing, scanning, or testing the Website for vulnerabilities, or attempting to breach
            any security or authentication systems without proper authorization. Any such activities may result in legal action.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>5. Unsolicited Communications</Heading>
          <Text>
            Sending unsolicited electronic messages, promotional emails, or advertising materials through the Website is strictly prohibited.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>6. Disclaimer</Heading>
          <Text>
            Doggle India does not warrant that the Website will function without error or that it is free of viruses or harmful components.
            If your use of the Website results in the need for servicing or replacing equipment or data, Doggle India is not responsible for any such costs.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>7. Social Media Engagement</Heading>
          <Text>
            Any communication or engagement on external social media platforms by this Website and its owners is subject to the terms
            and policies of the respective social media platforms.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>8. External Links</Heading>
          <Text>
            Users are advised to click on external links at their own risk. Doggle India and its owners cannot be held liable for any issues,
            damages, or consequences caused by visiting third-party links.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>9. Responsible Use of Social Media</Heading>
          <Text>
            We encourage users to interact wisely on social media. Doggle India will never ask for personal or sensitive information through these platforms.
            Sensitive matters should be addressed via email or direct call.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>10. Shortened URLs & Online Caution</Heading>
          <Text>
            Visitors should exercise caution before clicking on shortened URLs shared via our social platforms. Despite our best efforts to
            ensure only legitimate links are shared, Doggle India is not responsible for any harm caused by visiting malicious or spam links.
          </Text>
        </Box>

        <Box>
          <Heading fontSize="xl" mb={2}>Contact Us</Heading>
          <Text>Email: <Link href="mailto:hello@doggleindia.com" color="blue.600">hello@doggleindia.com</Link></Text>
          <Text>
            Website:{" "}
            <Link href="https://doggleindia.com" isExternal color="blue.600">
              https://doggleindia.com
            </Link>
          </Text>
        </Box>
      </Stack>
    </Box>
    <Footer />
    </>
  );
};

export default PrivacyPolicy;
